<template>
  <div class="body" v-if="dataPermission && dataPermission.includes('CNPS_ATTN_ADD_CREATE')">
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chấm công bổ sung/ Nghỉ phép</h1>
      <div class="float-right">
        <button @click="$router.go(-1)" class="f12 font-medium btn btn-outline-secondary mr-2">
          <i class="bx bx-arrow-back"></i> Quay lại
        </button>
        <button type="button" @click="submit('save')" class="f12 font-medium btn btn-success mr-2">
          <i class="bx bx-save"></i> Lưu
        </button>
        <button type="button" @click="submit('approved')" class="f12 font-medium btn btn-primary">
          <i class="bx bx-send"></i>Gửi duyệt
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <tr v-if="loading">
        <td colspan="12" align="center">
          <i class="bx bx-loader-circle bx-spin bx-rotate-90 f30"></i>
        </td>
      </tr>
      <div v-if="!loading" class="card-body px-20 row">
        <ValidationObserver
          ref="attAddForm"
          class="card-body px-20 mt-2 row"
          style="min-height: 600px"
        >
          <form class="col-md-6" @submit.prevent="validate().then(submit)">
            <div
              class="form-group row"
              v-if="
                (dataInsert.type === 'ATTN_ADD' &&
                  !typeCheckInOut.includes(dataInsert.reasonAttnAdd)) ||
                dataInsert.type !== 'ATTN_ADD'
              "
            >
              <div class="offset-sm-3 col-sm-9">
                <div class="checkbox">
                  <input
                    class="inp-cbx"
                    id="cbx01"
                    v-model="dataInsert.isMultiDay"
                    type="checkbox"
                    style="display: none"
                  />
                  <label class="cbx" for="cbx01">
                    <span>
                      <svg width="12px" height="10px" viewBox="0 0 12 10">
                        <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                      </svg>
                    </span>
                    Đăng ký nghỉ nhiều ngày
                  </label>
                </div>
                <p class="form-text text-muted well">
                  Đăng ký nghỉ nhiều ngày chỉ tính cho quên chấm công cả ngày hoặc nghỉ liên tục.
                  Quên check in hoặc check out hãy đăng ký riêng.
                </p>
              </div>
            </div>
            <ValidationProvider>
              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label"
                  >Kiểu <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <Select2
                    v-model="dataInsert.type"
                    :options="typeAddanceTimeKepping"
                    placeholder="Kiểu"
                  />
                  <p class="text-danger" v-show="!dataInsert.type">{{ errMessType }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-if="dataInsert.type === 'ATTN_ADD'"
              rules="required"
              vid="reasonAttnAdd"
              name="Loại"
            >
              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label"
                  >Loại chấm công <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <Select2
                    v-model="dataInsert.reasonAttnAdd"
                    :options="listReason"
                    placeholder="Loại chấm công"
                  />
                  <p class="text-danger" v-show="!dataInsert.reasonAttnAdd">
                    {{ errMessReasonAttn }}
                  </p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider
              v-if="
                dataInsert.type === 'ATTN_ADD' && typeCheckInOut.includes(dataInsert.reasonAttnAdd)
              "
            >
              <div class="form-group row">
                <label class="col-sm-3 col-form-label"
                  >Thời gian <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <div class="form-row">
                    <div class="col-12">
                      <datepicker
                        format="dd/MM/yyyy"
                        :language="vi"
                        v-model="dateCheckinCheckout"
                        placeholder="Chọn ngày"
                      ></datepicker>
                      <p class="text-danger" v-show="!dateCheckinCheckout">
                        {{ errDateCheckInOut }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider v-else>
              <div class="form-group row">
                <label class="col-sm-3 col-form-label"
                  >Bắt đầu - Kết thúc <span style="color: red">*</span></label
                >
                <div class="col-sm-9">
                  <div class="form-row minhtamhihi">
                    <div class="col-12">
                      <DateRangePicker
                        :ranges="false"
                        v-model="dateRange"
                        :locale-data="localeData"
                        class="w-100"
                        :timePicker="true"
                        :timePicker24Hour="true"
                      >
                        <template v-slot:input="picker">
                          <label style="min-width: 13.5em" class="text-left pt-1">
                            <span class="text-info">Ngày </span> :
                            {{ picker.startDate | formatDate }} |
                            <span class="text-info">Giờ </span> :
                            {{ dateRange.startDate | formatDate('HH:mm:00') }} <br />
                            <span class="text-info">Ngày </span> :
                            {{ picker.endDate | formatDate }} |
                            <span class="text-info">Giờ </span> :
                            {{ dateRange.endDate | formatDate('HH:mm:00') }}
                          </label>
                        </template>
                      </DateRangePicker>
                      <span class="icon-calendar"></span>
                    </div>
                  </div>
                  <p class="text-danger">{{ errMessDiffDate }}</p>
                </div>
              </div>
            </ValidationProvider>
            <ValidationProvider>
              <div class="form-group row">
                <label for="" class="col-sm-3 col-form-label">Ghi chú</label>
                <div class="col-sm-9">
                  <textarea class="form-control" rows="2" v-model="dataInsert.note"></textarea>
                </div>
              </div>
            </ValidationProvider>
          </form>

          <form class="col-md-6">
            <h1 class="form-inner-heading">Ảnh đính kèm</h1>
            <div class="form-group row img-list mr-0 ml-0">
              <ul>
                <li v-for="(item, index) in imageData" :key="index">
                  <a href="#popup-slider" data-toggle="modal">
                    <img :src="item" alt="" />
                    <span @click="removeImg(index)"><i class="bx bx-trash bx-sm"></i></span>
                  </a>
                </li>
                <li>
                  <div class="add-img">
                    <span class="bx bx-plus text-center"></span>
                    <input @input="onSelectFile" ref="fileInput" type="file" />
                  </div>
                </li>
              </ul>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
    <!--Modal thông báo-->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button
          size="sm"
          variant="light"
          v-if="successOrfalse == true"
          @click="closeModalSuccess()"
        >
          Đóng
        </b-button>
        <b-button size="sm" variant="light" v-else @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>

    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import thirdParty from '../../thirdParty/config'
  import { AttentdentService } from '@/services/attentdent.service'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import { mapGetters } from 'vuex'
  import { vi } from 'vuejs-datepicker/dist/locale'
  export default {
    data() {
      return {
        dataInsert: {
          type: '',
          isMultiDay: false,
        },
        dateRange: {
          startDate: moment(new Date().setHours(8, 30)).valueOf(),
          endDate: moment(new Date().setHours(17, 30)).valueOf(),
        },
        localeData: thirdParty.localeData,
        listReason: thirdParty.listReason,
        formData2: new FormData(),
        imageData: [],
        arrayImgInsertSuccess: [],
        arrayFormData: [],
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        errMessType: null,
        errMessReasonAttn: '',
        errMessDiffDate: '',
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        successOrfalse: false,
        dateCheckinCheckout: null,
        vi: vi,
        typeCheckInOut: ['FORGOT_ATTN_IN', 'FORGOT_ATTN_OUT'],
        showLoading: false,
        errDateCheckInOut: null,
      }
    },

    methods: {
      async submit(key) {
        try {
          if (!this.dataInsert.type || this.dataInsert.type === '') {
            this.errMessType = 'Loại không được để trống'
            return
          }

          if (this.dataInsert.type === 'ATTN_ADD' && !this.dataInsert.reasonAttnAdd) {
            this.errMessReasonAttn = 'Loại chấm công không được để trống'
            return
          }

          if (key === 'save') this.dataInsert.isSubmit = false
          if (key === 'approved') this.dataInsert.isSubmit = true

          if (
            this.dataInsert.type === 'ATTN_ADD' &&
            this.typeCheckInOut.includes(this.dataInsert.reasonAttnAdd)
          ) {
            delete this.dataInsert.endDate
            this.dataInsert.isMultiDay = false
            if (!this.dateCheckinCheckout) {
              this.errDateCheckInOut = 'Ngày không được để trống'
              return
            }
            this.dataInsert.startDate = moment(
              new Date(this.dateCheckinCheckout).setHours(8, 30)
            ).valueOf()
          } else {
            if (this.dataInsert.type !== 'ATTN_ADD') delete this.dataInsert.reasonAttnAdd
            const startDate = moment(this.dateRange.startDate).format('DD/MM/YYYY').valueOf()
            const endDate = moment(this.dateRange.endDate).format('DD/MM/YYYY').valueOf()
            if (startDate !== endDate && this.dataInsert.isMultiDay === false) {
              this.errMessDiffDate = 'Phải chọn đăng ký nghỉ nhiều ngày'
              return
            }
            this.dataInsert.startDate = moment(this.dateRange.startDate).valueOf()
            this.dataInsert.endDate = moment(this.dateRange.endDate).valueOf()
          }

          this.dataInsert.userId = this.dataUser.userId
          this.dataInsert.imageUrl = await this.uploadImg()

          this.showLoading = true
          const res = await AttentdentService.timekeepingAdd(this.dataInsert)
          if (res.code === 1000) {
            this.notiModal = true
            this.msgNoti = 'Thêm thành công'
            this.iconNoti = require('@/assets/img/noti-success2.svg')
            this.successOrfalse = true
            return
          }
          this.notiModal = true
          this.msgNoti = res.message || 'Đã có lỗi xảy ra'
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.successOrfalse = false
        } catch (e) {
          console.log(e)
          this.notiModal = true
          this.msgNoti = 'Lỗi hệ thống'
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.successOrfalse = false
        } finally {
          this.showLoading = false
        }
      },

      removeImg(index) {
        this.imageData.splice(index, 1)
        this.arrayFormData.forEach((e, i) => {
          if (index === i) {
            this.arrayFormData.splice(i, e)
          }
        })
      },

      async uploadImg() {
        if (this.arrayFormData.length > 0) {
          for (let index = 0; index < this.arrayFormData.length; index++) {
            const element = this.arrayFormData[index]
            await CommonService.uploadImg(element).then(ee => {
              if (ee.code === 1000) {
                this.arrayImgInsertSuccess.push(ee.data[0])
              }
            })
          }
        }
        return this.arrayImgInsertSuccess
      },

      closeModalSuccess() {
        this.$router.push('/timekeeping')
        this.notiModal = false
      },

      async onSelectFile() {
        const input = this.$refs.fileInput
        const files = input.files
        this.formData2 = new FormData()
        this.formData2.append('files', files[0])
        this.formData2.append('folderName', 'NextCrm')
        this.arrayFormData.push(this.formData2)
        if (files && files[0]) {
          const reader = new FileReader()
          reader.onload = e => {
            this.imageData.push(e.target.result)
          }
          reader.readAsDataURL(files[0])
          this.$emit('input', files[0])
        }
      },
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
        typeAddanceTimeKepping: 'common/typeAddanceTimeKepping',
      }),
    },
  }
</script>

<style>
  .minhtamhihi .reportrange-text[data-v-267f4ee2] {
    height: fit-content;
  }
</style>
